/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalFooter, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import './ClientSubscriptions.css';
import ErrorBoundary from '../general/ErrorBoundary';
import ClientSubscriptionDetail from './ClientSubscriptionDetail';

const ClientSubscriptionsTable = props => {

    // contexts
    const { theme } = useContext(ThemeContext);

    // states
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });
    const [subscriptions, setSubscriptions] = useState([]);
    const [tabName, setTabName] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showSubscriptionDetail, setShowSubscriptionDetail] = useState(-1);

    // useEffects
    useEffect(() => {
        setTabName(props.tabName);
    }, []);

    useEffect(() => {
        if (tabName) {
            setIsLoading(true);
            ProviderService.getClientSubscriptions(pagination.limit, pagination.page, pagination.searchVal, tabName === 'active')
                .then(subscriptions => {
                    // console.log('subscriptions', subscriptions);
                    try {
                        setSubscriptions(subscriptions.clientSubscriptions);
                        if (subscriptions.pagination.totalPages <= subscriptions.pagination.page) {
                            subscriptions.pagination.page = subscriptions.pagination.totalPages;
                        }
                        setPagination(subscriptions.pagination);
                        setIsLoading(false);
                    } catch (err) {
                        setIsLoading(false);
                        console.log("err", err);
                        Alert.error("Some error occured, please try again later or report support team.", {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        // GeneralService.logError('at BookSession useEffect2_1', err.stack);
                    }
                });
        }
    }, [tabName])

    // handle functions
    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Clients handlePagination', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        showSubscriptionDetail > -1 ?
            <div className="p-3">
                <div className='d-flex'>
                    <h3 className='mr-2' style={{ cursor: "pointer" }} onClick={() => setShowSubscriptionDetail(-1)}><i className="fas fa-arrow-left"></i></h3>
                    <h2 className='my-auto' style={theme.subHeadingSemibold}>Client Details</h2>
                </div>
                <hr />
                <ClientSubscriptionDetail subscription={subscriptions[showSubscriptionDetail]} />
            </div>
            :
            <div className="card mb-4">
                <div className="card-header d-flex">
                    <label className="my-auto">Client Subscriptions</label>
                </div>
                <div className="card-body py-0">
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>Client Name</th>
                                    <th>Purchased On</th>
                                    <th>Plan Name</th>
                                    <th>Status</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    subscriptions.map((item, index) => (
                                        <tr key={index}>
                                            <td>{`${item.client.title ? `${item.client.title} ` : ''} ${item.client.firstName} ${item.client.lastName}`}</td>
                                            <td>{moment(item.createdAt).format('MMM DD, YYYY')}</td>
                                            <td>{item.clientSubscriptionPlan.name}</td>
                                            <td>{item.isActive ? 'Active' : 'Inactive'}</td>
                                            <td align="center"><a style={{ color: "#384E73" }} href="#" onClick={() => setShowSubscriptionDetail(index)}>View details</a></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>                                      
                                    <td colSpan="6" className="border-0 pb-0">
                                        <div className="d-flex">
                                            <ErrorBoundary errorAt="At Admin Coupons Pagination">
                                                <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                <Pagination aria-label="Page navigation example" className="ml-auto">
                                                    <PaginationItem disabled={pagination.page == 1}>
                                                        <PaginationLink
                                                            onClick={e => handlePagination(e, pagination.page - 1)}
                                                            previous
                                                            href="#" />
                                                    </PaginationItem>
                                                    {[...Array(pagination.totalPages)].map((page, i) =>
                                                        <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                            <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                {i + 1}
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                    )}
                                                    <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                        <PaginationLink
                                                            onClick={e => handlePagination(e, pagination.page + 1)}
                                                            next
                                                            href="#" />
                                                    </PaginationItem>
                                                </Pagination>
                                            </ErrorBoundary>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
    )

}

export default ClientSubscriptionsTable;